import React from 'react';
import { ScrollView as RNScrollView, Platform, View } from 'react-native';

// Custom ScrollView that ensures proper scrolling on web
export const ScrollView = ({ children, style, contentContainerStyle, ...props }) => {
	if (Platform.OS === 'web') {
		return (
			<View style={[{ flex: 1, overflow: 'hidden' }, style]}>
				<RNScrollView
					style={{ flex: 1 }}
					contentContainerStyle={[{ flexGrow: 1 }, contentContainerStyle]}
					{...props}
				>
					{children}
				</RNScrollView>
			</View>
		);
	}

	return (
		<RNScrollView style={style} contentContainerStyle={contentContainerStyle} {...props}>
			{children}
		</RNScrollView>
	);
};

export default ScrollView;
